import { companySchema, CompanySchema } from '../models/Company';
import { FormTextInput, FormSubmitButton, FormCancelButton } from '@/components';
import useCompanyActions from '../hooks/useCompanyActions';
import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

const NewCompanyForm = () => {
  const navigate = useNavigate();
  const { onCreate } = useCompanyActions();

  const {
    handleSubmit,
    control,
    reset,
    formState: { isValid, isSubmitting },
  } = useForm<CompanySchema>({
    resolver: zodResolver(companySchema),
    mode: 'onChange',
    defaultValues: { name: '' },
  });

  const onSubmit = (data: CompanySchema) => onCreate(data, reset);

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className="w-full p-[50px] flex flex-col bg-white rounded-[5px] shadow-[0_0_4px_rgba(0,0,0,0.1)] gap-5"
    >
      <h1 className="mb-[15px] font-bold text-2xl">Ingresar datos de la compañía</h1>

      <div className="flex flex-col gap-2">
        <label className="text-sm font-medium text-gray-700">
          Nombre de la compañía
        </label>
        <FormTextInput
          control={control}
          name="name"
          placeholder="Nombre"
          autoFocus
          required
        />
      </div>

      <div className="flex gap-3 pt-2 justify-end">
        <FormCancelButton
          action={() => navigate('/fleet/companies')}
          disabled={isSubmitting}
        />
        <FormSubmitButton
          label={isSubmitting ? 'Creando...' : 'Crear compañía'}
          action={handleSubmit(onSubmit)}
          disabled={!isValid}
          isLoading={isSubmitting}
        />
      </div>
    </form>
  );
};

export default NewCompanyForm;
